import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { SettingsLock } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const RemovableStorage: FC = () => {
  const { t } = useContext(LocalizationContext);
  const isAvailable = useIsFeatureAvailable('removable_storage');

  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <Toggle
      label={t('settings.shell.security.removable.title')}
      description={t('settings.shell.security.removable.description')}
      value={settings.externalStorages}
      onChange={(value: string) => {
        setSetting({
          alias: ESettingsAliases.EXTERNAL_STORAGES,
          value: value ? '1' : '0',
        });
      }}
      variant="secondary"
      emptyBg
      disabled={!isAvailable}
      rightContent={!isAvailable ? <SettingsLock /> : undefined}
    />
  );
};
